import React from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';
const ProjectLoader = () => /*#__PURE__*/React.createElement(ContentLoader, {
  width: 150,
  height: 35,
  viewBox: "0 0 150 32"
}, /*#__PURE__*/React.createElement("rect", {
  x: "35",
  y: "12",
  rx: "3",
  ry: "3",
  width: "100",
  height: "8"
}), /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  rx: "8",
  ry: "8",
  width: "32",
  height: "32"
}));
ProjectLoader.displayName = 'ProjectLoader';
export default ProjectLoader;
//# sourceMappingURL=ProjectLoader.js.map